const localDatabase = {}

localDatabase.collection = function () {
  return this
}

localDatabase.onSnapshot = function () {
  return this
}

localDatabase.add = function () {
  return this
}

localDatabase.doc = function () {
  return this
}

localDatabase.set = function () {
  return this
}

localDatabase.where = function () {
  return this
}

export default localDatabase
